import { localeStorage } from '../localeStorage';
const baseLocale = 'cs';
export const getInitialLocale = (initialLocale) => {
    if (initialLocale) {
        return initialLocale;
    }
    const stored = localeStorage.get();
    return stored?.selectedLocale || baseLocale;
};
